import { basePost, baseGet } from "../api/base";

import apiEndPointList from "../constant/apiEndPointsList";

export const moduleService = {
    // translate text
    getModuleForUser: async ({ id_path}: { id_path: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.module.GET_ALL_MODULES_USER(id_path)
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi dịch ", err);
        }

        return response?.data;
    },

    getModuleForAdmin: async ({ id_path}: { id_path: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.module.GET_ALL_MODULES_ADMIN(id_path)
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi dịch ", err);
        }

        return response?.data;
    },

    getAllModules: async ({ id_path}: { id_path: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.module.GET_ALL_MODULES(id_path)
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi dịch ", err);
        }

        return response?.data;
    }

}

// export default moduleService;